"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PageNumberProvider = exports.PageNumberContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _useDebounce = require("use-debounce");
var _variables = require("../constants/variables");
var _useGetCatalogueStructure = require("../hooks/useGetCatalogueStructure");
var _getApiInstance = require("../utils/getApiInstance");
var _pageCounter = require("../utils/pageCounter");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const PageNumberContext = exports.PageNumberContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
PageNumberContext.displayName = 'PageNumberContext';
const PageNumberProvider = (param)=>{
    let { children, initialPageNumber } = param;
    const [initialPage, setInitialPage] = (0, _react.useState)(initialPageNumber !== null && initialPageNumber !== void 0 ? initialPageNumber : 1);
    const [currentPages, setCurrentPages] = (0, _react.useState)([
        initialPage
    ]);
    const [debouncedCurrentPages] = (0, _useDebounce.useDebounce)(currentPages, _variables.DEBOUNCE_DELAY);
    const [currentPagesInitialized, setCurrentPagesInitialized] = (0, _react.useState)(false);
    const { totalPageCount } = (0, _useGetCatalogueStructure.useGetCatalogueStructure)();
    const changePageNumber = (0, _react.useCallback)((input)=>{
        if (input === '') {
            return;
        }
        const page = (0, _pageCounter.transformPageInput)(input, totalPageCount);
        const ipaperApiInstance = (0, _getApiInstance.getApiInstance)();
        if (ipaperApiInstance) {
            ipaperApiInstance.paging.goToPage(page);
        }
    }, [
        totalPageCount
    ]);
    (0, _react.useLayoutEffect)(()=>{
        setInitialPage((0, _pageCounter.getPageNumberParamFromUrl)());
    }, []);
    (0, _react.useEffect)(()=>{
        if (totalPageCount !== 0) {
            const currentPage = (0, _pageCounter.transformPageInput)(initialPage, totalPageCount);
            setCurrentPages([
                currentPage
            ]);
        }
    }, [
        initialPage,
        totalPageCount
    ]);
    (0, _react.useEffect)(()=>{
        const currentPage = debouncedCurrentPages[0];
        if (currentPage != null) {
            (0, _pageCounter.updatePageNumberUrlParam)(currentPage);
        }
    }, [
        debouncedCurrentPages
    ]);
    const value = (0, _react.useMemo)(()=>({
            changePageNumber,
            currentPages,
            initialPage,
            totalPageCount,
            setCurrentPages,
            currentPagesInitialized,
            setCurrentPagesInitialized
        }), [
        changePageNumber,
        currentPages,
        initialPage,
        totalPageCount,
        currentPagesInitialized
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PageNumberContext.Provider, {
        value: value,
        children: children
    });
};
exports.PageNumberProvider = PageNumberProvider;
